<template>
  <div>
    <v-alert
      :text="alertContent"
      density="compact"
      type="warning"
      color="#ececec"
      class="pa-2"
    ></v-alert>
  </div>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      required: true,
      default: null,
    },
    alertContent: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.mdi-alert-circle {
  color: $primaryColor !important;
  padding-right: 20px;
}

.v-alert__content {
  color: $iconColor !important;
}
</style>
